module.exports = __webpack_public_path__ + "media/images/pc/top/soudan_comment-02-8362527ff9759c2693719cd713962d45.svg";